import React, {createContext, useContext} from "react";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";

const ViewItemBatcherContext = createContext({
    registerView: () => {
    }
});

export function ViewItemBatcherProvider({children}) {
    const {registerView} = useViewItemBatcher();
    return (
        <ViewItemBatcherContext.Provider value={{registerView}}>
            {children}
        </ViewItemBatcherContext.Provider>
    );
}

export function withViewItemBatcher(Component) {
    return function Wrapper(props) {
        const {registerView} = useContext(ViewItemBatcherContext);
        return <Component {...props} registerView={registerView} />;
    };
}
